import gql from 'graphql-tag';

import integrationItemFragment from './integrationItemFragment';

export const duplicateFileFragment = gql`
  fragment duplicateFileFragment on DuplicateFile {
    dokkioClass
    id
    fileCount
    mostRecentlyModifiedIntegrationFile {
      ...integrationItemFragment
    }
  }
  ${integrationItemFragment}
`;
export default duplicateFileFragment;
